export enum SuborderType {
  PROJECT = "project",
  STOCK = "stock",
  DOCKYARD = "dockyard",
}

export const SUBORDER_TYPE_LABELS: Record<SuborderType, string> = {
  [SuborderType.PROJECT]: "Projet",
  [SuborderType.STOCK]: "Stock",
  [SuborderType.DOCKYARD]: "Chantier",
};
